export const enrollmentInfo = {
  availableDates: {
    switchServiceDates: [
      '2020-03-02',
      '2020-03-03',
      '2020-03-04',
      '2020-03-06',
      '2020-03-07',
      '2020-03-09',
      '2020-03-11',
      '2020-03-13',
      '2020-03-14',
      '2020-03-15',
      '2020-03-16',
      '2020-03-17',
      '2020-03-20',
      '2020-03-22',
    ],
  },
  disclaimers: [
    'I designate Infinite Energy to complete the necessary tasks to become my electric service from my current REP to Infinite Energy. You will receive a copy of these documents via email and US mail, that will explain all the terms of the agreement and how to exercise the right of rescission, if applicable. You can further request a copy to be sent via US mail at any time.',
  ],
  fees: {
    distributorFees: {
      moveInCharges: '320¢',
    },
  },
  requiredPlanEnrollmentFields: null,
  terms: [],
};
